import React, { Component } from 'react';

export default class AirlineListItem extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return <tr>
            <td><a href={this.props.airline}>{this.props.title}</a></td>
            <td className="hidden-xs">{this.props.iataCode}</td>
            <td className="hidden-xs">{this.props.phone}</td>
            <td className="hidden-sm hidden-xs"><a href={this.props.website} target="_blank">{this.props.websiteName}</a></td>
            <td className="text-right">{this.props.rating}</td>
        </tr>;
    }

}



// WEBPACK FOOTER //
// ./AirlineListApp/components/AirlineListItem.jsx